import { createSlice } from "@reduxjs/toolkit"



const initialState = {
    Topnavigate: [2, 'Home'],
    LeftMenuNavigate: '',
    LeftHeadMenu: '',
    TOP_NAVIGATION: '',
    LEFT_MENU_NAVIGATION: '',
    SUB_LEFT_MENU_NAVIGATION: '',
    PageName: '',
    loading: false,
    error: false,
    landingpage: true,
    Pageactive: true,
    avgActiveTab: 'Mcap'
}


export const ReduxLocalSlice = createSlice({
    name: "NavigationSlice",
    initialState,
    reducers: ({
        SetTopMenuNavigation: (state, action) => {
            state.Topnavigate = action.payload
            state.loading = false
            state.error = false
        },
        setLeftHeadMenu: (state, action) => {
            state.LeftHeadMenu = action.payload
        },
        SetLeftMenuTap: (state, action) => {
            state.LeftMenuNavigate = action.payload
        },
        setPageName: (state, action) => {
            state.PageName = action.payload
        },
        Set_TOP_NAVIGATION: (state, action) => {
            state.TOP_NAVIGATION = action.payload
        },
        Set_LEFT_MENU_NAVIGATION: (state, action) => {
            state.LEFT_MENU_NAVIGATION = action.payload
        },
        Set_SUB_LEFT_MENU_NAVIGATION: (state, action) => {
            state.SUB_LEFT_MENU_NAVIGATION = action.payload
        },
        SetLandingPage: (state, action) => {
            state.landingpage = action.payload
        },
        SetPageactive: (state, action) => {
            state.Pageactive = action.payload
        },
        SetPageactiveToggle: (state, action) => {
            state.Pageactive = !state.Pageactive
        },
        setAvgActiveTab: (state, action) => {
            state.avgActiveTab = action.payload
        },

    })
})


export const {
    SetTopMenuNavigation,
    SetLeftMenuTap,
    setLeftHeadMenu,
    setPageName,
    Set_TOP_NAVIGATION,
    Set_LEFT_MENU_NAVIGATION,
    Set_SUB_LEFT_MENU_NAVIGATION,
    SetLandingPage,
    setAvgActiveTab,
    SetPageactive,
    SetPageactiveToggle
} = ReduxLocalSlice.actions
export default ReduxLocalSlice.reducer
